import * as React from 'react';
import { Container } from '@grandvisionhq/elements';

const Layout = ({ children  })=>{
    return /*#__PURE__*/ React.createElement(Container, {
        className: "returns-layout"
    }, children);
};
var Layout$1 = Layout;

export { Layout$1 as default };
//# sourceMappingURL=Layout.js.map
